import { createContext } from 'react';

const UserContext = createContext({
  initialized: false,
  user: null,
  setUser: () => {},
  accessToken: null,
  setAccessToken: () => {},
});

export default UserContext;
